export const MASKS: Dic<string> = {
  "Masque 2": "60:C0:BF:2A:D0:AB",
  "Masque 3": "60:C0:BF:29:D9:71",
  "Masque 4": "60:C0:BF:29:F7:D4",
  "Masque 5": "60:C0:BF:2A:83:D6",
  "Masque 6": "60:C0:BF:2A:C8:1B",
  "Masque 7": "60:C0:BF:2A:83:7F",
  "Masque 8": "60:C0:BF:2A:6B:9C",
  "Masque 9": "60:C0:BF:2A:8F:5A",
  "Masque 10": "60:C0:BF:2A:83:CA",
  "Masque 10H": "60:C0:BF:2A:76:26",
};

export const MASK_STATUS_TO_LABEL: Record<MaskStatus, string> = {
  CONNECTING: "Connexion en cours",
  CONNECTED: "Connecté",
  DISCONNECTED: "Déconnecté",
  ERROR: "Erreur",
};
